var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnother(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "case__footer__icon",
    "data-animation": "rotation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    style: {
      transform: "rotate(121.5deg)"
    },
    width: 48,
    height: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.4276 34.45L11.3276 23.56L0.52755 24.82L8.71755 17.71L0.52755 10.51L11.3276 11.86L10.4276 0.969999L17.2676 9.43L24.1976 0.969999L23.2075 11.86L34.0076 10.51L25.8176 17.71L34.0076 24.82L23.2075 23.56L24.1976 34.45L17.2676 25.9L10.4276 34.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnother);
export default __webpack_public_path__ + "static/media/another.98b9a2edecc7e76b584d8c1558fee71b.svg";
export { ForwardRef as ReactComponent };